<!-- 主页面 -->
<template>
  <div class="image dashboard" >
    <!-- 导航 -->
    <div style="position: absolute;top: 17px;right: 0px;overflow: hidden;">
      <img :src="`/img/haiqora/main-right-bottom${this.$router.history.current.query.lang === 'en' ?'_en' :''}.png`" style="height: 52px;margin-right: -5px; position: relative; right: -3px;"/>
    </div>
    <md-card style="position: absolute;right: 0px;z-index: 0;top: 57px;background: #F3F8FF; box-shadow:0 4px 4px rgba(0,0,0,0.1);height: 161px;border-radius: 11px;left: 11px;width: auto;border-bottom-right-radius: 0;">
      <md-card-content style="padding-top: 5px;padding-left: 18px;">
        <p class="small-title">Introduction to the use of the process</p>
        <div style="width:100%;height: 10px;margin-top: 3px;margin-left: -5.5px;" class="md-layout">
          <div class="md-layout-item md-size-45 left-layout-item ml-auto">
            <div class="step-box">
              <div class="step-title-box">
                <div class="step-num-box">1</div>
                <div class="step-title">Improvement of organizational structure</div>
              </div>
              <div>
                <span>Add department</span>>
                <span>Add Personnel</span>>
                <span>Add Region</span>>
                <span>Add Device</span>
              </div>
            </div>
          </div>
          <div class="md-layout-item md-size-5 left-layout-item ml-auto">
          </div>
          <div class="md-layout-item md-size-45 left-layout-item ml-auto">
            <div class="step-box">
              <div class="step-title-box">
                <div class="step-num-box">2</div>
                <div class="step-title">Access control settings</div>
              </div>
              <div>
                <span>Add access control group</span>>
                <span>Access authorization</span>>
                <span>Synchronization to devices</span>
              </div>
            </div>
          </div>
          <div class="md-layout-item md-size-5 left-layout-item ml-auto">
          </div>
        </div>
      </md-card-content>
    </md-card>
    <!-- 影子 -->
    <div style="height: 165px;width: 1px;"></div>
    <!--  -->
    <div class="md-layout" style="margin-left: -15px;width:calc(100% + 15px);">
      <div class="md-layout-item info-box" style="width:25%;height: 210px;">
        <h5>Quick navigation</h5>
      </div>
      <div class="md-layout-item info-box" style="width:25%;height: 210px;">
        <h5>Institutional Information</h5>
      </div>
      <div class="md-layout-item info-box" style="width:50%;height: 210px;">
        <h5>Door opening method</h5>
      </div>
    </div>
  </div>
</template>
<script>
// import { timestampToString} from "@/common/tools.js"; // nDaysAgo , 

// Echart
// import * as echarts from "echarts";
// import 'echarts/map/js/world.js'

export default {
  data(){
    return {
    }
  },
  computed:{
  },
  mounted(){  },
  methods:{
  },
};
</script>
<style lang="scss" scoped>
  .info-box{
    margin:15px 10px 10px;
    padding: 13px 18px;
    background: #FFF;
    min-height: 1px;
  }
  h5{
    font-weight: 500;
    margin:0 ;
  }
  .image.dashboard{
    margin-right: 0px !important;
    overflow-x:hidden;
  }
  .step-box{
    min-height:120px;
    margin:0 4.5px;
    border-top-left-radius: 9px;
    border-bottom-right-radius: 9px;
    border-bottom-left-radius: 5px;
    border-top-right-radius: 5px;
    background: #FFF; 
  }
  .step-title-box{
    display: flex;
  }
  .step-num-box{
    height: 22px;
    line-height: 22px;
    width: 33px;
    text-align: center;
    font-size: 18px;
    font-weight: 400;
    color: #FFFFFF;
    background: linear-gradient(to bottom, #5990FF, #4E87FB);
    border-top-left-radius: 9px;
    border-bottom-right-radius: 9px;
  }
  .step-title{
    line-height: 22px;
    font-size: 16px;
    font-weight: 400;
    margin-left: 13px;
  }
  .right-button{
    position: absolute;
    right: 20px;
    top: 10px;
  }
  .white-button{
    padding: 0 20px;
    line-height: 32px;
    border-radius: 4px;
    border: 1px solid #ddd;
    text-align:center;
    transition: box-shadow .2s;
    cursor:pointer;
    font-weight: 400;
  }
  .md-layout-item .white-button{
    line-height: 60px;
    margin: 0;
  }
  .white-button:hover{
    box-shadow: 1px 1px 1px #c9c9c994;
  }
  .dashboard{
    overflow:auto;
  }
  .plat-qa{
    border-right: 1px solid #aaa;
    padding: 10px 20px 10px 5px;
    margin-right:10px;
    font-weight:600;
    font-size: 17px;
  }
  .title{
    font-weight:600;
    font-size: 17px;
  }
  .select-box{
    display:flex;
  }
  .app-card-p {
    color: #000;
    display: inline;
    position: absolute;
    top: 0px;
    right: 0;
    padding: 6px 12px;
    border-radius : 4px;
    font-weight: 400;
  }
  .select-box>div{
    margin-left: 10px;
    margin-right: 10px;
    padding: 10px;
    font-weight:400;
    font-size: 14px;
    border-radius: 6px;
    background: #f8f8f8;

    cursor:pointer;
  }
  .image{
    // height: 700px;
    color: #555;
    clear: both;
    background-repeat: no-repeat;
    background-size: cover;

    // line-height: 650px;
    // background-image: url(/img/welcome.jpg);
    // text-align: center;
    // font-size: 60px;
  }
  @media screen and ( max-width: 600px ){
    .image{
      font-size: 48px;
      height: calc( 100vh - 132px);
      line-height: calc( 100vh - 182px );
    }
  }
  .md-layout-item .version {
    transition: all 0s;
  }
  .line{
    content: "";
    height: 1px;
    width: calc(100% - 15px);
    background-color: rgba(180, 180, 180, 0.3);
  }
  .sec-side{
    font-size: 16px;
    font-weight: 300;
    height: 70px;
    width: 200px;
    box-sizing: border-box;
    padding: 15px 12px;
    line-height: 40px;
  }
  .sec .menu-item-box{
    height: 60px; 
    padding: 8px 12px;
    display: flex;
    margin-right: 8px;
  }
  .menu-item-box{
    font-size: 14px;
    height: 40px;
    margin: 6px 0;
    box-sizing: border-box;
    padding: 4px 12px;
    line-height: 32px;
    // width: calc( 100% - 15px );
    cursor: pointer;
    border-radius: 4px;
    transition: background .2s;
  }
  .menu-item-box.selected{
    background: #00bcd4;
    color: #ffffff;
  }
  .menu-item-box:hover{
    background: #f4f4f4;
  }
  .menu-item-box.selected:hover{
    background: #00bcd4;
  }

  .tabs-content{
    width : 200px;
    box-shadow : none;
    border-right : 1px solid #ddd;
    border-radius: 0;
    margin-right : 18px;
  }
  .product-card-img{
    display: flex;
    align-items: center;
    padding-left: 0;
  }
  .product-card-img img{
    flex-shrink : 0;
  }
  .product-card-p {
    background-color: #eeeeee;
    display: inline;
    padding: 6px 12px;
    border-radius : 4px;
    font-weight: 400;
  }
  .tabs-contant{
    padding-top : 40;
    width: calc(100% - 240px);
    box-shadow: none;
  }
  .left-table {
    text-align: left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .order-card{
    margin:8px 0;
  }
  .order-card .order-card-title span{
    margin-right : 10px;
  }

  .order-card .order-card-title-state {
    float : right;
    position : absolute;
    top : 0px;
    right : 40px;
    
  }
  .order-card .success {
    color : #4caf50;
  }
  .order-card .warning {
    color : #f44336;
  }
  .order-card .line {
    height : 1px;
    margin : 0 20px;
    background-color : rgb(238, 238, 238);
  }
  .order-card .foot-box {
    text-align : left;
    width : 100%;
  }
  .order-card .foot-box .foot-box-left {
    margin-left :16px;
  }
  .order-card .foot-box .foot-box-right {
    float : right;
    margin-right : 16px;
  }
  .card-form {
    margin-top: 0;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-right:0px;
    padding-left :0px;
  }
  .no-margin-layout-item {
    padding-left:0;
    padding-right: 0;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }
</style>